var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { useHistoryStore } from "@/stores/historyStore";
import { addFavoriteToolQuery, removeFavoriteToolQuery, getCurrentUser, setCurrentThemeQuery, } from "@/stores/users/queries";
export const useUserStore = defineStore("userStore", () => {
    const toggledSideBar = ref("tools");
    const showActivityBar = ref(false);
    const currentUser = ref(null);
    const currentPreferences = ref(null);
    let loadPromise = null;
    const isAnonymous = computed(() => {
        return !("email" in (currentUser.value || []));
    });
    const currentTheme = computed(() => {
        var _a, _b;
        return (_b = (_a = currentPreferences.value) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : null;
    });
    const currentFavorites = computed(() => {
        var _a;
        if ((_a = currentPreferences.value) === null || _a === void 0 ? void 0 : _a.favorites) {
            return currentPreferences.value.favorites;
        }
        else {
            return { tools: [] };
        }
    });
    function setCurrentUser(user) {
        currentUser.value = user;
    }
    function loadUser() {
        if (!loadPromise) {
            loadPromise = getCurrentUser()
                .then((user) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                const historyStore = useHistoryStore();
                currentUser.value = Object.assign(Object.assign({}, user), { isAnonymous: !user.email });
                currentPreferences.value = (_a = user === null || user === void 0 ? void 0 : user.preferences) !== null && _a !== void 0 ? _a : null;
                // TODO: This is a hack to get around the fact that the API returns a string
                if ((_b = currentPreferences.value) === null || _b === void 0 ? void 0 : _b.favorites) {
                    currentPreferences.value.favorites = JSON.parse((_d = (_c = user === null || user === void 0 ? void 0 : user.preferences) === null || _c === void 0 ? void 0 : _c.favorites) !== null && _d !== void 0 ? _d : { tools: [] });
                }
                yield historyStore.loadCurrentHistory();
                // load first few histories for user to start pagination
                yield historyStore.loadHistories();
            }))
                .catch((e) => {
                console.error("Failed to load user", e);
            })
                .finally(() => {
                loadPromise = null;
            });
        }
    }
    function setCurrentTheme(theme) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!currentUser.value || currentUser.value.isAnonymous) {
                return;
            }
            const currentTheme = yield setCurrentThemeQuery(currentUser.value.id, theme);
            if (currentPreferences.value) {
                currentPreferences.value.theme = currentTheme;
            }
        });
    }
    function addFavoriteTool(toolId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!currentUser.value || currentUser.value.isAnonymous) {
                return;
            }
            const tools = yield addFavoriteToolQuery(currentUser.value.id, toolId);
            setFavoriteTools(tools);
        });
    }
    function removeFavoriteTool(toolId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!currentUser.value || currentUser.value.isAnonymous) {
                return;
            }
            const tools = yield removeFavoriteToolQuery(currentUser.value.id, toolId);
            setFavoriteTools(tools);
        });
    }
    function setFavoriteTools(tools) {
        if (currentPreferences.value) {
            currentPreferences.value.favorites.tools = tools !== null && tools !== void 0 ? tools : { tools: [] };
        }
    }
    function toggleActivityBar() {
        showActivityBar.value = !showActivityBar.value;
    }
    function toggleSideBar(currentOpen = "") {
        toggledSideBar.value = toggledSideBar.value === currentOpen ? "" : currentOpen;
    }
    return {
        currentUser,
        currentPreferences,
        isAnonymous,
        currentTheme,
        currentFavorites,
        showActivityBar,
        toggledSideBar,
        loadUser,
        setCurrentUser,
        setCurrentTheme,
        addFavoriteTool,
        removeFavoriteTool,
        toggleActivityBar,
        toggleSideBar,
    };
}, {
    persist: {
        paths: ["showActivityBar", "toggledSideBar"],
    },
});
